import { DownloadIcon, MoreVertical, RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useDownload } from '@/hooks/useDownload';

interface ActionMenuProps {
  downloadUrl?: string;
  fileName?: string;
  fileExtension?: string | null;
  onRefresh?: () => void;
}

export const ActionMenu = ({
  downloadUrl,
  fileName,
  fileExtension,
  onRefresh,
}: ActionMenuProps) => {
  const { downloadFile } = useDownload();

  const handleDownload = () => {
    if (!downloadUrl) return;
    downloadFile({
      downloadUrl,
      name: fileName || 'download',
      fileExtension,
    });
  };

  return (
    <div className="shrink-0">
      <DropdownMenu>
        <Tooltip delayDuration={200}>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="sm"
                className="h-6 w-6 p-0 transition-all hover:bg-muted active:scale-95"
              >
                <MoreVertical size={14} className="text-muted-foreground" />
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="text-[10px] py-1 px-2">
            Actions
          </TooltipContent>
        </Tooltip>
        <DropdownMenuContent align="end" className="w-[160px]">
          {onRefresh && (
            <DropdownMenuItem onClick={onRefresh} className="cursor-pointer">
              <RefreshCw size={14} className="mr-2" />
              <span>Refresh</span>
            </DropdownMenuItem>
          )}
          {downloadUrl && (
            <DropdownMenuItem
              onClick={handleDownload}
              className="cursor-pointer"
            >
              <DownloadIcon size={14} className="mr-2" />
              <span>Download file</span>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ActionMenu;
